let Messages = require('./messages');
let Http     = require('./http');

module.exports = {
	mixins: [Messages, Http],

	props: {
		user: {
			type: Object
		},
	},
	
	methods: {
		
		getUrlParam(name) {
			name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
			var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
			var results = regex.exec(location.search);
			return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
		}
	}
};
